// extracted by mini-css-extract-plugin
module.exports = {"container":"impactcard-module--container--1Q5TT","header":"impactcard-module--header--1VfAk","subheading":"impactcard-module--subheading--1cCyf"};